import { TbShieldCheck } from "solid-icons/tb";
import {
  actionsDemo,
  followThroughDemo,
  multiplayerDemo,
  offerFlowDemo,
  roundTripDemo,
} from "~/components/marketing/demo";
import {
  ActionsMockup,
  FollowThroughMockup,
  MultiplayerMockup,
  OfferFlowMockup,
  RoundTripMockup,
} from "~/components/marketing/mockups";
import { CardArrow, LINK_CARD, SplitRow } from "~/components/marketing/ui";
import { useI18n } from "~/i18n";

export const RoundTripSection = () => {
  const { t } = useI18n();
  return (
    <SplitRow
      id="execs-prep"
      index="01"
      eyebrow={t("marketing.executives.prep.eyebrow")}
      title={t("marketing.executives.prep.title")}
      body={t("marketing.executives.prep.body")}
      visual={<RoundTripMockup data={roundTripDemo(t)} />}
    />
  );
};

export const FollowUpSection = () => {
  const { t } = useI18n();
  return (
    <SplitRow
      id="execs-followup"
      index="02"
      eyebrow={t("marketing.executives.followup.eyebrow")}
      title={t("marketing.executives.followup.title")}
      body={t("marketing.executives.followup.body")}
      visual={<FollowThroughMockup data={followThroughDemo(t)} />}
      reverse
    />
  );
};

export const AutopilotSection = () => {
  const { t } = useI18n();
  return (
    <SplitRow
      id="execs-autopilot"
      index="03"
      eyebrow={t("marketing.executives.autopilot.eyebrow")}
      title={t("marketing.executives.autopilot.title")}
      body={t("marketing.executives.autopilot.body")}
      visual={<ActionsMockup data={actionsDemo(t)} />}
    />
  );
};

export const OffersSection = () => {
  const { t } = useI18n();
  return (
    <SplitRow
      id="execs-offers"
      index="04"
      eyebrow={t("marketing.home.offers.eyebrow")}
      title={t("marketing.executives.offers.title")}
      body={t("marketing.executives.offers.body")}
      visual={<OfferFlowMockup data={offerFlowDemo(t)} />}
      reverse
    >
      <a
        href="/features#trust"
        style={{ "--c": "#3049cf" }}
        class={`flex items-start gap-2.5 rounded-xl border border-primary-border bg-tile px-4 py-3 text-sm font-medium ${LINK_CARD}`}
      >
        <TbShieldCheck class="mt-px size-5 shrink-0 text-brand" aria-hidden="true" />
        <span class="flex-1">{t("marketing.home.offers.trust")}</span>
        <CardArrow />
      </a>
    </SplitRow>
  );
};

export const TogetherSection = () => {
  const { t } = useI18n();
  return (
    <SplitRow
      id="execs-together"
      index="05"
      eyebrow={t("marketing.home.multi.eyebrow")}
      title={t("marketing.executives.together.title")}
      body={t("marketing.executives.together.body")}
      visual={<MultiplayerMockup data={multiplayerDemo(t)} />}
    />
  );
};
